// import React, { useState, useEffect } from "react";
// import Drawer from "Common/Components/Drawer";
// import { X } from "lucide-react";
// import Segment from "../PageView/SegmentOrderModal/Segment";
// import _ from "lodash";
// import { HTML5Backend } from "react-dnd-html5-backend";
// import { DndProvider } from "react-dnd";
// import Button from "Common/Components/ButtonComponent/Button";
// import BlogSegment from "./BlogSegment";

// const BlogOrderModal = ({
//   isVisible,
//   onClose,
// //   pageId,
//   getSegmentData,
//   loader,
//   setLoader,
// }) => {

// //   useEffect(() => {
// //     let newOrder = {};
// //     pageView?.page_order.forEach((item) => {
// //       newOrder[item?.segment_id] = item.order;
// //     });
// //     setPageOrder(pageView?.page_order);
// //     setOriginalPageOrder(newOrder);
// //   }, [pageView]);

// //   const [pageOrder, setPageOrder] = useState(pageView?.page_order);

// //   const [originalPageOrder, setOriginalPageOrder] = useState({});

// //   const moveCardUp = (currentIndex) => {
// //     let oldPageOrder = [...pageOrder];
// //     if (currentIndex > 0) {
// //       // Swap current element with the one above it
// //       const temp = oldPageOrder[currentIndex];
// //       oldPageOrder[currentIndex] = oldPageOrder[currentIndex - 1];
// //       oldPageOrder[currentIndex - 1] = temp;
// //     }
// //     // Update order numbers
// //     const newPageOrder = oldPageOrder.map((item, index) => {
// //       item.order = index + 1;
// //       return item;
// //     });
// //     setPageOrder(newPageOrder);
// //   };

// //   const moveCardDown = (currentIndex) => {
// //     let oldPageOrder = [...pageOrder];
// //     if (currentIndex < oldPageOrder.length - 1) {
// //       // Swap current element with the one below it
// //       const temp = oldPageOrder[currentIndex];
// //       oldPageOrder[currentIndex] = oldPageOrder[currentIndex + 1];
// //       oldPageOrder[currentIndex + 1] = temp;
// //     }
// //     // Update order numbers
// //     const newPageOrder = oldPageOrder.map((item, index) => {
// //       item.order = index + 1;
// //       return item;
// //     });
// //     setPageOrder(newPageOrder);
// //   };

// //   const handleSaveOrder = async () => {
// //     let input = pageOrder.map((item, index) => {
// //       return {
// //         segment_id: item.segment_id,
// //         order: item.order,
// //       };
// //     });

// //     let res = await callApi(`v1/page/${pageId}/swap-order`, "post", {
// //       segmentOrders: input,
// //     });
// //     if (res.status === "Success") {
// //       setLoader(!loader);
// //       onClose();
// //     }
// //   };



//   return (
//     <Drawer
//       show={isVisible}
//       onHide={onClose}
//       id="drawerEnd"
//       drawer-end="true"
//       className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
//     >
//       <Drawer.Header
//         className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
//         closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
//       >
//         <div className="flex items-center justify-between w-full">
//           <Drawer.Title className="text-15">{"Select Order"}</Drawer.Title>
//           <div className="flex items-center gap-4">
//             <button
//             //   onClick={() => handleSaveOrder()}
//               className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
//             >
//               Save Order
//             </button>
//             <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
//           </div>
//         </div>
//       </Drawer.Header>
//       <Drawer.Body className="h-full p-4 overflow-y-auto">
//         <div className="grid grid-cols-12 gap-x-5">
//           {getSegmentData?.map((item, index) => (
//             <div key={item._id} className="col-span-12">
//               <BlogSegment
//                 // originalPageOrder={originalPageOrder}
//                 // moveCardUp={moveCardUp}
//                 // moveCardDown={moveCardDown}
//                 segment_type={item.segment_type}
//                 segment_id={item.segment_id}
//                 // index={index}
//                 // order={item.order}
//                 totalLength={getSegmentData?.length}
//                 data={getSegmentData(item)}
//               />
//             </div>
//           ))}
//         </div>
//       </Drawer.Body>
//     </Drawer>
//   );
// };

// export default BlogOrderModal;




import React, { useState, useEffect } from "react";
import Drawer from "Common/Components/Drawer";
import { X } from "lucide-react";
import _ from "lodash";
import callApi from "Common/utils/apiCaller";
import BlogSegment from "./BlogSegment";

const BlogOrderModal = ({ isVisible, onClose, getSegmentData, loader, setLoader }) => {
    // Initialize pageOrder with the segment data converted to order array
    const [pageOrder, setPageOrder] = useState([]);
    const [originalPageOrder, setOriginalPageOrder] = useState({});

    useEffect(() => {
  if (getSegmentData?.length) {
    // Sort getSegmentData by rank ascending
    const sortedData = _.sortBy(getSegmentData, ['rank']);
    const initialOrder = sortedData.map((item, idx) => ({
      segment_id: item._id,
      order: idx + 1,
      ...item,
    }));
    setPageOrder(initialOrder);

    const originalOrderMap = {};
    sortedData.forEach((item, idx) => {
      originalOrderMap[item._id] = idx + 1; // reflecting sorted order
    });
    setOriginalPageOrder(originalOrderMap);
  }
}, [getSegmentData]);


    const moveCardUp = (currentIndex) => {
        if (currentIndex > 0) {
            const newOrder = [...pageOrder];
            [newOrder[currentIndex], newOrder[currentIndex - 1]] = [newOrder[currentIndex - 1], newOrder[currentIndex]];
            newOrder.forEach((item, index) => {
                item.order = index + 1;
            });
            setPageOrder(newOrder);
        }
    };

    const moveCardDown = (currentIndex) => {
        if (currentIndex < pageOrder.length - 1) {
            const newOrder = [...pageOrder];
            [newOrder[currentIndex], newOrder[currentIndex + 1]] = [newOrder[currentIndex + 1], newOrder[currentIndex]];
            newOrder.forEach((item, index) => {
                item.order = index + 1;
            });
            setPageOrder(newOrder);
        }
    };

    const handleSaveOrder = async () => {
        // if (!pageId) return;
        const input = pageOrder.map((item) => ({
            _id: item.segment_id,
            rank: item.order,
        }));

        console.log(input)

        const res = await callApi(`v1/blogsegment/update-rank`, "post", { "update": input });
        if (res.status === "Success") {
            setLoader(!loader);
            onClose();
        }
    };

    return (
        <Drawer
            show={isVisible}
            onHide={onClose}
            id="drawerEnd"
            drawer-end="true"
            className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
        >
            <Drawer.Header
                className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
                closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
            >
                <div className="flex items-center justify-between w-full">
                    <Drawer.Title className="text-15">Select Order</Drawer.Title>
                    <div className="flex items-center gap-4">
                        <button
                            onClick={handleSaveOrder}
                            className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                        >
                            Save Order
                        </button>
                        <button onClick={onClose} aria-label="Close">
                            <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50" />
                        </button>
                    </div>
                </div>
            </Drawer.Header>
            <Drawer.Body className="h-full p-4 overflow-y-auto">
                <div className="grid grid-cols-12 gap-x-5">
                    {pageOrder.map((item, index) => (
                        <div key={item.segment_id} className="col-span-12">
                            <BlogSegment
                                segment_type={item.heading}
                                segment_id={item.segment_id}
                                index={index}
                                totalLength={pageOrder.length}
                                data={item}
                                moveCardUp={moveCardUp}
                                moveCardDown={moveCardDown}
                                originalPageOrder={originalPageOrder}
                            />
                        </div>
                    ))}
                </div>
            </Drawer.Body>
        </Drawer>
    );
};

export default BlogOrderModal;
